module.exports = __webpack_public_path__ + "static/media/git.e676d9e5.png";